import { getCommonHeaderProps } from "PFApp/components/card_tx/card_tx.utils";
import { CardTxContentProps } from "PFApp/components/card_tx/card_tx_content";
import { QuestionSuggestionContent } from "PFApp/components/card_tx/content/question_suggestion_content";
import { Footer } from "PFApp/components/card_tx/footer/footer";
import { Header } from "PFApp/components/card_tx/header/header";
import { Status } from "PFApp/components/card_tx/status/status";

export type QuestionSuggestionVariantProps = Pick<
  CardTxContentProps,
  "activity" | "type" | "isFeed" | "isDraft" | "handleShare" | "handleRefetchActivities"
>;

export const QuestionSuggestionVariant = ({
  activity,
  type,
  isFeed,
  isDraft,
  handleShare,
  handleRefetchActivities
}: QuestionSuggestionVariantProps) => {
  const commonHeaderProps = getCommonHeaderProps({
    activity,
    type,
    isFeed,
    handleShare,
    handleRefetchActivities
  });

  return (
    <>
      <Header {...commonHeaderProps} />
      <Status isPrivate={activity.private} isDraft={isDraft} />
      <QuestionSuggestionContent activity={activity} type={type.key} />
      <Footer participants={activity.participants} />
    </>
  );
};
